import * as config from '../../common/config';

export const links = [
  config.routes.PRIVACY,
  //config.routes.TERMS,
  config.routes.CONTACT,
  config.externalLinks.BLOG,
];